import type { IKeyof } from "./typeTools";

import { notify } from "@/components/atoms/notify";
import type { IOption } from "@/interfaces";
import { EmptyOption } from "@/interfaces";

export function showValidationErrors(errors: object) {
  const entries = Object.entries(errors);

  let errorsText = "";

  for (const [key, value] of entries) {
    if (value) {
      errorsText += `${key}: ${value}\n`;
    }
  }

  if (errorsText.trim()) {
    notify.error(errorsText);
  }
}

export function clearFieldsDependencyValue<TFormik>(
  setFieldValue: (name: string, value: IOption | IOption[]) => void,
  dependencies: IKeyof<TFormik> | IKeyof<TFormik>[] | undefined,
  inputType: "select" | "multiSelect",
) {
  // clear the dependency fields value
  if (dependencies === undefined) return;
  if (typeof dependencies === "string")
    setFieldValue(dependencies, inputType === "select" ? EmptyOption : []);
  else {
    for (const dependencyFieldName of dependencies) {
      setFieldValue(
        dependencyFieldName,
        inputType === "select" ? EmptyOption : [],
      );
    }
  }
}
